import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class HomeAuthGuardService implements CanActivate {
    constructor(public router: Router, private authService: AuthService, private cookies: CookieService, @Inject(PLATFORM_ID) private platformId: Object) {}

    canActivate(): boolean {
        if (this.getUserRole() && this.getUserRole().trim() !== '') {
            const redirectUrl = localStorage.getItem('redirectUrl');
            if ( redirectUrl ) {
                window.location.href = redirectUrl;
                localStorage.removeItem('redirectUrl')
            } else {
                return true;
            }
        }
        return false;
    }

    getUserRole() {
        if (isPlatformBrowser(this.platformId)) {
            return this.cookies.get('userRole');
        } else {
            return null;
        }
    }
}
